import { EnvironmentSpecific } from "./environment.interface";

const website = "https://energyplatform.nl";

export const energyplatform: EnvironmentSpecific = {
  identifier: "nl.energyplatform",
  hasAuthentication: false,
  iosAppstoreId: "1515520660",
  calendarColor: "orange",
  type: "learning",
  environmentName: "energyplatform",
  website,
  contact: `${website}/contact/`,
  name: "EnergyPlatform",
  youtube: "https://www.youtube.com/channel/UCW3nM-TdY0w4xpXH9rZz71A/",
  instagram: "https://www.instagram.com/energyplatform/",
  facebook: "https://www.facebook.com/EnergyPlatform-667736646619784/",
  terms: `${website}/wp-content/themes/energyplatform/assets/pdf/Gebruiksvoorwaarden%20Employee%20Wellbeing%20Company%20voor%20EnergyPlatform%20App.pdf`,
  privacy: `${website}/wp-content/themes/energyplatform/assets/pdf/Privacy%20en%20cookie%20voorwaarden%20Employee%20Wellbeing%20Company%20BV.pdf`,
  oneSignalAppId: "e995d064-0057-4e07-88b9-9fd72a5c23c9",
};
